export default {
  "hash": "c99a725",
  "raw": "v3.32.0",
  "semverString": "3.32.0"
};